import { render } from "./ProfileVue.vue?vue&type=template&id=66973e99"
import script from "./ProfileVue.vue?vue&type=script&lang=js"
export * from "./ProfileVue.vue?vue&type=script&lang=js"

import "./ProfileVue.vue?vue&type=style&index=0&id=66973e99&lang=css"

import exportComponent from "/Users/adamklemm/vues/pmp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__